export default "__VITE_ASSET__CeDgHILA__"